// Base URLs used by the web app. Override with environment variables at build time
// (CRA reads REACT_APP_* from .env). Defaults keep the current production behaviour.
const trimSlash = (url) => String(url || "").replace(/\/+$/, "");

export const API_BASE_URL = trimSlash(
  process.env.REACT_APP_BACKEND_URL ||
    "https://ota-backend.altariumconsulting.com"
);

export const WEB_BASE_URL = trimSlash(
  process.env.REACT_APP_WEB_BASE_URL ||
    "https://ota-admin.altariumconsulting.com"
);
